/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_LedeInputs */

const tr_landing_pricerules_lede = /** @type {(inputs: Landing_Pricerules_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD ve EUR kurlarını takip edin, kendi kurallarınızı yazın. Kur değişince sistem her ürünün yeni fiyatını hesaplar; fark belirlediğiniz yüzdeyi ya da TL tutarını aşınca sizi uyarır. Onaylayın ya da kuralı otomatik uygulamaya alın. Hepsiburada'da Buybox'ı taban fiyat korumasıyla otomatik kovalayın.`)
};

const en_landing_pricerules_lede = /** @type {(inputs: Landing_Pricerules_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track USD and EUR rates and write your own rules. When a rate moves, the system calculates each product's new price and alerts you once the gap exceeds your percentage or TL threshold. Approve, or let the rule apply automatically. On Hepsiburada, chase the Buybox automatically with floor-price protection.`)
};

const de_landing_pricerules_lede = /** @type {(inputs: Landing_Pricerules_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgen Sie USD und EUR und schreiben Sie eigene Regeln. Ändert sich der Kurs, berechnet das System für jedes Produkt den neuen Preis und warnt Sie, sobald die Differenz Ihre Prozent- oder TL-Schwelle überschreitet. Bestätigen Sie oder lassen Sie die Regel automatisch anwenden. Auf Hepsiburada jagen Sie die Buybox automatisch mit Mindestpreisschutz.`)
};

const ru_landing_pricerules_lede = /** @type {(inputs: Landing_Pricerules_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следите за курсами USD и EUR и создавайте собственные правила. При изменении курса система рассчитывает новую цену каждого товара и предупреждает вас, когда разница превышает ваш порог в процентах или в TL. Подтвердите или включите для правила автоприменение. На Hepsiburada автоматически боритесь за Buybox с защитой минимальной цены.`)
};

/**
* | output |
* | --- |
* | "Track USD and EUR rates and write your own rules. When a rate moves, the system calculates each product's new price and alerts you once the gap exceeds your ..." |
*
* @param {Landing_Pricerules_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_lede = /** @type {((inputs?: Landing_Pricerules_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_lede(inputs)
	if (locale === "de") return de_landing_pricerules_lede(inputs)
	if (locale === "ru") return ru_landing_pricerules_lede(inputs)
	return tr_landing_pricerules_lede(inputs)
});